<template>
    <div>
        <slot :companyPeople='companyPeople'></slot>
    </div>
</template>

<script>

export default {
    name: "MembershipForm",

    props: {
        company: {
        }
    },

    data() {
        return {
            companyPeople: null,
        }
    },

    mounted() {
        EventBus.$on('added-participant', this.getPeople);
        EventBus.$on('updated-participant', this.getPeople);
        
        this.getPeople();
    },

    methods: {
        
        getPeople(){
            if(this.company){
                axios.get('/api/participants?paginate=false&companyId=' + this.company.id)
                    .then(response => {
                        //console.log('got people', response.data);
                        this.companyPeople = response.data;
                    });
            }
            
        }
    }
}
</script>

<style>

</style>